module.exports = __webpack_public_path__ + "static/media/biopas.3bb1f4b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/biopas.png
// module id = 142
// module chunks = 0